import React from 'react';
import { Button } from 'carbon-components-react';

const IdentityIntegration: React.FC<Props> = () => {
  const handleClickManageEnterprise = () => {
    window.open(
      `${process.env.REACT_APP_IDENTITY_WEB_URL}/enterprise`,
      'enterpriseNewWindow'
    );
  };
  return (
    <div
      id="identityIntegration"
      className="identity-integration spacing-padding"
    >
      <div className="sub-section-title">Identity integration (Enterprise)</div>
      <div className="section-description">
        Modify enterprise settings like SSO roles and account provisioning
      </div>
      <div className="button-container">
        <Button
          kind="tertiary"
          size="default"
          className="button-size"
          onClick={handleClickManageEnterprise}
        >
          Manage enterprise
        </Button>
      </div>
    </div>
  );
};

interface Props {
  user: any;
}

export default React.memo(IdentityIntegration);
